import styled from 'styled-components';

export const Import = styled.div`
  color: #6a8799;
`;
